export const ROLE_LABELS = {
  super_admin: "Super Admin",
  hod: "HOD / Dept Head",
  senior_associate: "Senior Associate",
  junior_associate: "Junior Associate",
  client: "Client",
  // legacy fallbacks
  member_1: "Senior Associate",
  member_2: "Senior Associate",
  member_3: "Senior Associate",
  member_4: "Senior Associate",
};

export const TEAM_ROLE_OPTIONS = ["super_admin", "hod", "senior_associate", "junior_associate", "client"];

export const SERVICE_CATEGORIES = {
  "Environmental Clearance": ["Fresh EC", "Amendment EC", "Expansion EC", "Corrigendum EC", "CRZ Clearance"],
  "MPCB": ["CTE", "CTO", "CTO Renewal"],
  "Compliance": ["ECMP Retainer", "PMR", "Six Monthly Compliance", "Form-V", "Monitoring"],
  "Environmental Systems": ["STP", "ETP", "Grey Water System", "OWC", "AQMS", "OCEMS", "Anti Smog Gun"],
};

export const LEAD_STAGES = [
  "Enquiry",
  "Meeting",
  "Proposal Sent",
  "Negotiation",
  "Work Order",
  "Lost",
];

// Per PT spec — exact dropdown options for Lead Service Required
export const LEAD_SERVICE_OPTIONS = [
  "Environment Clearance + Integrated CTE",
  "Expansion in EC",
  "Revalidation of EC",
  "Corrigendum of EC",
  "Amendment of EC",
  "ECMP Post EC",
  "CRZ Clearance",
  "CRZ + EC Clearance",
  "Consent to Establish",
  "Consent to Operate",
  "MEP Services",
  "Post Monitoring Report Submission",
  "Form V Submission",
  "Other - Specify",
  "NA",
];

// Per PT spec — exact dropdown options for Lead Product Required
export const LEAD_PRODUCT_OPTIONS = [
  "Sewage Treatment Plant",
  "Organic Waste Composter",
  "Grey water treatment Plant",
  "Micro Ambient Air Quality Monitoring System",
  "Anti-Smog Gun",
  "Other - Specify",
  "NA",
];

export const LEAD_SOURCE_OPTIONS = ["Website", "Referral", "LinkedIn", "Cold Call", "Existing", "Other"];
export const LEAD_PROPOSAL_STATUS_OPTIONS = ["Not Sent", "Draft", "Sent", "Accepted", "Rejected"];

export const PROPOSAL_STATUSES = ["Draft", "Submitted for Approval", "Approved", "Rejected", "Sent", "Accepted", "Closed"];
export const WO_STATUSES = ["Pending", "Received", "Approved"];
export const INVOICE_STATUSES = ["Raised", "Sent", "Partially Paid", "Paid"];
export const TASK_STATUSES = ["Open", "In Progress", "On Hold", "Closed"];

export const STATUS_COLORS = {
  // proposals
  Draft: "bg-stone-100 text-stone-700",
  "Submitted for Approval": "bg-amber-100 text-amber-800",
  Approved: "bg-emerald-100 text-emerald-800",
  Sent: "bg-sky-100 text-sky-800",
  Accepted: "bg-emerald-200 text-emerald-900",
  Rejected: "bg-rose-100 text-rose-800",
  Closed: "bg-stone-200 text-stone-800",
  // wo
  Pending: "bg-amber-100 text-amber-800",
  Received: "bg-sky-100 text-sky-800",
  Approved: "bg-emerald-100 text-emerald-800",
  // invoices
  Raised: "bg-stone-100 text-stone-700",
  "Partially Paid": "bg-amber-100 text-amber-800",
  Paid: "bg-emerald-100 text-emerald-800",
  // tasks
  Open: "bg-sky-100 text-sky-800",
  "In Progress": "bg-amber-100 text-amber-800",
  "On Hold": "bg-stone-100 text-stone-700",
  Closed: "bg-emerald-100 text-emerald-800",
  // documents
  Uploaded: "bg-sky-100 text-sky-800",
  // compliance
  Scheduled: "bg-stone-100 text-stone-700",
  "Sample Collected": "bg-sky-100 text-sky-800",
  "Report Received": "bg-amber-100 text-amber-800",
};

export const fmtINR = (n) => "₹" + (Number(n) || 0).toLocaleString("en-IN");
